<div class="suggestion-icons">
  <div class="suggestion-title" [style.border-color]="borderColor">
    <span>Recommended Action</span>
  </div>
  <div class="suggestion-content" [class]="suggestionClass">
    <div class="suggestion-content-inner">
      <mat-icon class="suggestion-icon">{{expenseSuggestionData.icon}}</mat-icon>
      <p>{{expenseSuggestionData.text}}</p>

      <app-button text="Re-check" (clicked)="suggestApproval()" faIcon="fas fa-rotate" [isBusy]="loading" variant="info" size="sm" />
    </div>
    <ul class="receipt-check-reasons" *ngIf="receiptCheckReasons?.length">
      <li *ngFor="let reason of receiptCheckReasons">{{ reason }}</li>
    </ul>
  </div>
</div>
